var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeHoboLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_140_1",
    "data-name": "Component 140 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 323.154,
    height: 50.938,
    viewBox: "0 0 323.154 50.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 167.742,
    height: 50.933,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(155.412 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M143.212,1.524A5.21,5.21,0,0,0,139.447,0a5.317,5.317,0,0,0-3.769,1.5,5.221,5.221,0,0,0-1.572,3.854V20.031h-22.87V5.351A5.209,5.209,0,0,0,106.17,0q-.141,0-.283,0a5.316,5.316,0,0,0-3.775,1.5,5.223,5.223,0,0,0-1.574,3.854v40a5.309,5.309,0,0,0,5.27,5.349h.079a5.219,5.219,0,0,0,3.852-1.574,5.3,5.3,0,0,0,1.5-3.775V30.012H134.1V45.351a5.322,5.322,0,0,0,10.64.289c0-.1,0-.193,0-.289v-40a5.283,5.283,0,0,0-1.524-3.827",
    transform: "translate(-100.537 -0.002)",
    fill: "#0dd8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M167.093,17.87a17.412,17.412,0,0,0-6.649-6.687,18.964,18.964,0,0,0-9.485-2.394,19.233,19.233,0,0,0-9.567,2.391,17.133,17.133,0,0,0-6.662,6.7,20.682,20.682,0,0,0,0,19.168,17.133,17.133,0,0,0,6.662,6.7,20.275,20.275,0,0,0,19.111,0,17.18,17.18,0,0,0,6.627-6.687,20.565,20.565,0,0,0-.037-19.179M155.205,35.184a8.742,8.742,0,0,1-8.491,0,7.685,7.685,0,0,1-2.911-3.055,9.448,9.448,0,0,1-1.084-4.617,9.623,9.623,0,0,1,1.09-4.656,7.65,7.65,0,0,1,2.9-3.075,8.742,8.742,0,0,1,8.491,0,7.465,7.465,0,0,1,2.866,3.055,9.86,9.86,0,0,1,1.07,4.676,9.684,9.684,0,0,1-1.067,4.637,7.5,7.5,0,0,1-2.869,3.019Z",
    transform: "translate(-83.159 4.794)",
    fill: "#0dd8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M194.116,22.813a17.015,17.015,0,0,0-22.526-7.576,16.9,16.9,0,0,0-1.77.983V5.291a5.236,5.236,0,0,0-1.495-3.8,5.533,5.533,0,0,0-7.533-.026,5.174,5.174,0,0,0-1.552,3.823V32.233a18.8,18.8,0,0,0,2.458,9.494,18.212,18.212,0,0,0,16.064,9.208,18.694,18.694,0,0,0,9.44-2.461,17.849,17.849,0,0,0,6.726-6.758,18.976,18.976,0,0,0,2.422-9.484,19.98,19.98,0,0,0-2.241-9.423m-23.438,4.863A7.913,7.913,0,0,1,173.6,24.58a8.324,8.324,0,0,1,8.337,0,8.126,8.126,0,0,1,2.968,3.11,9.161,9.161,0,0,1,1.105,4.542,9.3,9.3,0,0,1-1.11,4.58,8.05,8.05,0,0,1-13.97.461c-.088-.145-.172-.294-.25-.444a9.5,9.5,0,0,1-1.09-4.6,9.342,9.342,0,0,1,1.087-4.559",
    transform: "translate(-68.496 -0.002)",
    fill: "#0dd8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M219.762,17.87a17.412,17.412,0,0,0-6.649-6.687,18.964,18.964,0,0,0-9.485-2.394,19.233,19.233,0,0,0-9.567,2.391,17.133,17.133,0,0,0-6.662,6.7,20.682,20.682,0,0,0,0,19.168,17.133,17.133,0,0,0,6.662,6.7,20.275,20.275,0,0,0,19.111,0,17.194,17.194,0,0,0,6.628-6.687,20.57,20.57,0,0,0-.039-19.179M207.874,35.184a8.742,8.742,0,0,1-8.491,0,7.686,7.686,0,0,1-2.911-3.055,9.448,9.448,0,0,1-1.084-4.617,9.623,9.623,0,0,1,1.09-4.656,7.65,7.65,0,0,1,2.9-3.075,8.742,8.742,0,0,1,8.491,0,7.465,7.465,0,0,1,2.866,3.055,9.861,9.861,0,0,1,1.07,4.676,9.683,9.683,0,0,1-1.067,4.637,7.5,7.5,0,0,1-2.869,3.019Z",
    transform: "translate(-54.411 4.794)",
    fill: "#0dd8ad"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113564",
    "data-name": "Group 113564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M16.049,6.095A16.049,16.049,0,1,1,0,22.144,16.048,16.048,0,0,1,16.049,6.095",
    transform: "translate(0 3.327)",
    fill: "#f0f3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M47.9,6.095A16.049,16.049,0,1,1,31.855,22.144,16.048,16.048,0,0,1,47.9,6.095",
    transform: "translate(17.387 3.327)",
    fill: "#0dd8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M79.26,6.095A16.049,16.049,0,1,1,63.211,22.144,16.048,16.048,0,0,1,79.26,6.095",
    transform: "translate(34.502 3.327)",
    fill: "#028090"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_109_1",
    "data-name": "Component 109 \\u2013 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 323.154,
    height: 50.938,
    fill: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeHoboLogo);
export default __webpack_public_path__ + "static/media/ne-hobo-logo.8be8928c31e0bf1e9129998023f5aebf.svg";
export { ForwardRef as ReactComponent };